<template>
  <v-row>
    <v-col class="6">
      <!-- 商品番号 -->
      <v-text-field
        v-model="inputedValue.number"
        outlined
        dense
        hide-details
        :placeholder="$t('product.product_product-number')"
        :height="height"
      >
      </v-text-field>
    </v-col>
    <v-col cols="6">
      <!-- 商品カテゴリ -->
      <SelectProductCategory v-model="inputedValue.category" />
    </v-col>
  </v-row>
</template>

<script>
import { SelectProductCategory } from '@/components/items/Selectboxes'

export default {
  components: {
    SelectProductCategory
  },
  props: {
    value: {},
    height: { default: '32px' }
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
